import { render, staticRenderFns } from "./articleIndex.vue?vue&type=template&id=4e217950&scoped=true"
import script from "./articleIndex.vue?vue&type=script&lang=js"
export * from "./articleIndex.vue?vue&type=script&lang=js"
import style0 from "./articleIndex.vue?vue&type=style&index=0&id=4e217950&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e217950",
  null
  
)

export default component.exports